module.exports = class EmbedModal {
  async embedModal(embedName) {
    const item = JSON.parse(localStorage.getItem('itemEmbed'))
    const embedcodejs = ` <div class="container" id="vid_${item.id}" style="position:relative;width:100%;padding: 56.25% 0 0;"> <img id="thumb_${item.id}" src="${item.vsl_frame}" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;"> </div> <script type="text/javascript" id="scr_${item.id}">var s=document.createElement("script");s.id="teste", s.src="https://vsl-booster-prod.s3.amazonaws.com/min/script.min.js",s.type="module", s.async=!0,document.head.appendChild(s); </script> `
    const embedcodeIframe = `<iframe
              style="width: 100%; height: 500px; frameborder: 0; allow: autoplay; encrypted-media; allowfullscreen"
              srcdoc='<div class="container" id="vid_${item.id}" style="position:relative;width:100%;padding: 56.25% 0 0;"> <img id="thumb_${item.id}" src="${item.vsl_frame}" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;"> </div> <script type="text/javascript" id="scr_${item.id}">var s=document.createElement("script");s.id="teste", s.src="https://vsl-booster-prod.s3.amazonaws.com/min/script.min.js",s.type="module", s.async=!0,document.head.appendChild(s); </script>'
          ></iframe>`
    const embedjs = {
      name: 'Código JS',
      embed: embedcodejs,
    }
    const embediframe = {
      name: 'Código Iframe',
      embed: embedcodeIframe,
    }

    if (embedName === 'Código JS') {
      return embedjs
    }
    if (embedName === 'Código Iframe') {
      return embediframe
    }
  }
}
